export default "__VITE_ASSET__bc98fa54__"